import React, { FC } from "react";
import { useLabels } from "../Hooks/useLabels";

import { BookingFaqDto } from "../../../../Api/Model/BookingFaqDto.csharp";
import { FAQAccordionItem } from "./FAQAccordionItem";

type FAQAccordionType = {
  localFAQ?: BookingFaqDto[];
};

export const FAQAccordion: FC<FAQAccordionType> = ({
  localFAQ = [],
}) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;
  const globalFAQ = fourthStepLabels?.globalFAQ.faq ?? [];

  const faq = [...localFAQ, ...globalFAQ];

  function mapFAQToElements(element: BookingFaqDto, index: number) {
    return <FAQAccordionItem {...element} key={`faqItem-${index}`} className="FAQAccordion__item" />;
  }

  return (
    <section className="FAQAccordion">
        <h2 className="FAQAccordion__title">
          {fourthStepLabels?.globalFAQ.faqHeading ?? 'Vanlige spørsmål og svar' }
        </h2>
      {faq.length != 0 && <div>{faq.map(mapFAQToElements)}</div>}
    </section>
  );
};
